import Button from '@allesauto/core/button';
import CircularLoader, {
  CircularLoaderType,
} from '@allesauto/core/circularLoader';
import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import { isAuregoShop } from '@allesauto/utils/funcs.ts';
import clsx from 'clsx';
import * as React from 'react';

import { WL_INTEGRATION_WINTER_LAUSITZ } from '@/features/whitelabel/util/getWhiteLabelIntegrationSlugs';

interface OverlayFormFooterProps {
  buttonText?: string;
  onButtonClick?: () => void;
  showButtonLoader?: boolean;
  isButtonDisabled?: boolean;
  className?: string;
  icon?: JSX.Element;
  buttonTestId?: string;
  fullWidth?: boolean;
  isFromAccessory?: boolean;
}

const OverlayFormFooter: React.FC<
  React.PropsWithChildren<OverlayFormFooterProps>
> = ({
  buttonText,
  children,
  onButtonClick,
  showButtonLoader = false,
  isButtonDisabled,
  className: customClassName,
  icon,
  buttonTestId,
  fullWidth = false,
  isFromAccessory = false,
}) => {
  const trackingIdentifierButton = `aa-overlay--success--btn`;
  const whiteLabel = useWhiteLabel();
  const isWinterInstance =
    whiteLabel?.merchantOrigin === WL_INTEGRATION_WINTER_LAUSITZ;

  const className = {
    wrapper: `add-border-overlay absolute bottom-0 h-auto md:h-100px left-0 right-0 flex-col md:flex-row flex justify-center md:justify-between md:items-center px-15px md:px-0 py-20px md:py-0 z-20 ${
      isWinterInstance ? 'wl-bg-highlight' : ''
    }`,
    button: `md:!h-full md:!rounded-none md:w-3/10 lg:w-3/10 px-0 ${
      isFromAccessory && 'monochrome:!text-white'
    }
    ${
      isWinterInstance
        ? 'wl-custom-bg-highlight border-0'
        : isAuregoShop(whiteLabel) && 'border-t-0 '
    }`,
  };

  return (
    <div
      className={clsx(
        className.wrapper,
        React.Children.count(children)
          ? 'bg-purple80 monochrome:bg-grey90'
          : 'bg-transparent md:bg-purple80 md:monochrome:bg-grey90',
        customClassName
      )}
    >
      <div>{children}</div>

      <Button
        disabled={isButtonDisabled}
        text={showButtonLoader ? undefined : buttonText}
        customClassName={className.button}
        onClick={onButtonClick}
        icon={icon}
        isLoading={showButtonLoader}
        whitelabel={true}
        id={buttonTestId}
        data-tracking-id={trackingIdentifierButton}
        fullWidth={fullWidth}
      >
        {showButtonLoader && (
          <CircularLoader type={CircularLoaderType.primary} />
        )}
      </Button>
    </div>
  );
};

export default OverlayFormFooter;
